import React, { useEffect, useState } from "react";
import { getActiveCountries, getLegalPagesCountryBase } from "src/api/api";
import Loader from "src/components/Loader";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs, { tabsClasses } from '@mui/material/Tabs';
import { Link as RouterLink } from 'react-router-dom';
// Material
import { Container, Stack, Typography, Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
// components

const columns = [
    { field: 'pageName', headerName: 'Page Name', width: 120 },
    {
        field: 'country',
        headerName: 'Country',
        width: 100,
        renderCell: (params) => (params?.value ? String(params.value).toUpperCase() : '—')
    },
    { field: 'pageSlug', headerName: 'Page Slug', width: 130 },
    { field: 'metaTitle', headerName: 'Meta Title', width: 140 },
    { field: 'metaDescription', headerName: 'Meta Description', width: 150 },
    { field: 'content', headerName: 'Content', width: 150 },
    { field: 'canonicalLink', headerName: 'Canonical Link', width: 130 },
    {
        field: 'action',
        headerName: 'Action',
        width: 130,
        renderCell: (rowData) => (
            <Button
                fullWidth
                size="medium"
                variant="contained"
                color="primary"
                component={RouterLink}
                to={`/dashboard/pages/edit-page${rowData.row.pageSlug}/${rowData.row.country}`}
            >
                Edit
            </Button>
        )
    }
];

export default function Pages() {
    const [countries, setCountries] = useState([]);
    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState(0);

    function a11yProps(index) {
        return {
            id: `blog-section-tab-${index}`,
            'aria-controls': `blog-section-tabpanel-${index}`
        };
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        let isMounted = true;

        const fetchCountries = async () => {
            try {
                setLoading(true)
                const countriesRes = await getActiveCountries();
                if (isMounted && countriesRes.success) setCountries(countriesRes.countries || []);
            } catch (error) {
                console.error("Failed to fetch countries:", error);
            } finally {
                if (isMounted) setLoading(false)
            }
        };

        fetchCountries();

        return () => { isMounted = false; };
    }, []);

    if (loading) {
        return <Loader />
    }

    return (
        <>
            <Box sx={{ mt: 2 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="h4" gutterBottom>
                        Pages
                    </Typography>
                    {countries.length ? (
                        <Button
                            variant="contained"
                            color="primary"
                            component={RouterLink}
                            to={`/dashboard/pages/create-page/${countries[value].countrySlug}`}
                        >
                            Create Page
                        </Button>
                    ) : null}
                </Stack>

                <Box sx={{ width: '100%' }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="scrollable"
                        scrollButtons
                        aria-label="blog detail sections tabs"
                        sx={{
                            [`& .${tabsClasses.scrollButtons}`]: {
                                '&.Mui-disabled': { opacity: '0.3' }
                            }
                        }}
                    >
                        {countries.map((country, index) => (
                            <Tab label={country.countryName} {...a11yProps(index)} key={country._id} />
                        ))}
                    </Tabs>
                </Box>
            </Box>
            {countries.length ?
                <PagesPerCountry key={countries[value]._id} country={countries[value]} />
                : null}
        </>
    )
}

function PagesPerCountry({ country }) {
    const [pages, setPages] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        let isMounted = true;

        const getPages = async () => {
            try {
                setLoading(true)
                const pagesRes = await getLegalPagesCountryBase({ country_id: country._id });
                if (isMounted && pagesRes.success == true) {
                    setPages(pagesRes.pages.map((e) => ({ ...e, country: country.countrySlug })))
                }
            } catch (error) {
                console.error("Failed to fetch countries:", error);
            } finally {
                if (isMounted) setLoading(false)
            }
        };

        getPages();

        return () => { isMounted = false; };
    }, [country]);

    return (
        <>
            <Container>

                <Stack direction="row" alignItems="center" justifyContent="space-between" my={2}>
                    <Typography variant="h6" gutterBottom>
                        Data Table
                    </Typography>
                </Stack>
                {loading ? (
                    <Loader />
                ) : (
                    <Stack
                        sx={{ boxShadow: 3, borderRadius: 1, border: '1px solid #929eaa6b', width: '100%' }}
                    >
                        <DataGrid
                            rows={pages}
                            columns={columns}
                            getRowId={(row) => row?._id}
                            pageSize={10}
                            rowsPerPageOptions={[10]}
                            disableSelectionOnClick
                            autoHeight={true}
                        />
                    </Stack>
                )}
            </Container>
        </>
    )
}